import { filter, tap, switchMap } from 'rxjs/operators';
import { Component, Input, OnInit } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable, merge, of, Subject } from 'rxjs';
//import { MatDialog } from '@angular/material/dialog';

import * as fromRoot from '../../reducers';
import * as forms from '../../actions/forms';
import * as support from '../../actions/support';
import * as utils from '../../shared/utils';
import * as notifications from '../../actions/notifications';

@Component({
  selector: 'edge-void-email-change',
  templateUrl: './void-email-change.component.html',
  styleUrls: ['./void-email-change.component.scss']
})
export class VoidEmailChangeComponent implements OnInit {
  @Input() sport: string = '';
  @Input() email: string = '';
  @Input() vcode: string = '';

  formName = 'voidEmailChange';
  submitted = false;
  public voidEmailChangeForm: FormGroup;

  validationMessages: any = {
    sport: { required: 'Please indicate a sport' },
    emailAddress: {
      required: 'Please provide your email address',
      email: 'Please provide a valid email address'
    },
    verificationCode: { required: 'Please provide your verification code' }
  };

  action$ = new Subject();
  formAction$: Observable<Action> = this.action$.pipe(
    tap(() => (this.submitted = true)),
    switchMap((data) =>
      of(forms.FormRequestAction(utils.fromForm(this.formName, data))).pipe(
        filter(() => this.voidEmailChangeForm.valid)
      )
    )
  );

  constructor(
    private store: Store<fromRoot.State>,
    private formBuilder: FormBuilder
    //public dialog: MatDialog
  ) {
    merge(this.formAction$).subscribe(store);
    store.dispatch(forms.FormCreateAction({ formName: this.formName }));
    this.buildVoidEmailChangeForm();
  }

  buildVoidEmailChangeForm(): void {
    this.voidEmailChangeForm = this.formBuilder.group({
      sport: [{ value: '', disabled: true }, Validators.required],
      emailAddress: [
        '',
        Validators.compose([Validators.required, Validators.email])
      ],
      verificationCode: ['', Validators.required]
    });
  }

  hasError(key: string, type: string): boolean {
    const control = this.voidEmailChangeForm.controls[key];
    return control.errors ? control.errors[type] : false;
  }

  getErrorMessage(key: string, type: string): string {
    return this.validationMessages[key][type];
  }

  onSubmit(): void {
    if (!this.voidEmailChangeForm.valid) {
      this.store.dispatch(
        notifications.AddFailureNotification(
          'Please fix the form errors and try again.'
        )
      );
    }
    this.action$.next(this.voidEmailChangeForm.value);
  }

  ngOnInit(): void {
    this.store.dispatch(support.ToggleSupportPageAction(this.sport));
    this.voidEmailChangeForm.controls.sport.setValue(this.sport);
    this.voidEmailChangeForm.controls.emailAddress.setValue(this.email);
    this.voidEmailChangeForm.controls.verificationCode.setValue(this.vcode);
  }
}
